import React from 'react';
import { Check } from 'lucide-react';
interface CheckboxRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
}
export function CheckboxRow({
  checked,
  onChange,
  label,
  description
}: CheckboxRowProps) {
  return <label className="flex items-start gap-3 cursor-pointer group" data-id="element-212">
      <div className="relative flex items-center mt-0.5" data-id="element-213">
        <input type="checkbox" className="sr-only" checked={checked} onChange={e => onChange(e.target.checked)} data-id="element-214" />
        <div className={`
            w-5 h-5 rounded border flex items-center justify-center transition-colors
            ${checked ? 'bg-violet-600 border-violet-600' : 'bg-white border-gray-300 group-hover:border-violet-400'}
          `} data-id="element-215">
          {checked && <Check size={14} className="text-white" data-id="element-216" />}
        </div>
      </div>
      <div className="flex-1" data-id="element-217">
        <p className={`text-sm font-medium ${checked ? 'text-gray-900' : 'text-gray-700'}`} data-id="element-218">
          {label}
        </p>
        {description && <p className="text-xs text-gray-500 mt-1" data-id="element-219">{description}</p>}
      </div>
    </label>;
}